import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as TopRightBannerSVG } from "./tips-bg.svg";

interface Props {
	color?: string;
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
	root: {
		"& path": {
			fill: ({ color }) => (color ? color : theme.palette.primary.main),
		},
	},
}));

export const TopRightBanner = ({ color }: Props) => {
	const classes = useStyles({ color });
	return (
		<div style={{ position: "fixed", top: 0, right: 0, zIndex: -1 }}>
			<TopRightBannerSVG className={classes.root} />
		</div>
	);
};
